require("./src/utils/styles/global.scss");

exports.onClientEntry = () => {
   if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
         (position) => {
            const existingLocaleObj =
               JSON.parse(localStorage.getItem("_ew_locale")) || {};

            const { latitude, longitude } = position.coords;
            const newObj = {
               ...existingLocaleObj,
               geoCoords: { lat: latitude, lng: longitude },
            };

            // Store the location in localStorage
            localStorage.setItem("_ew_locale", JSON.stringify(newObj));
         },
         (error) => {
            console.error("Error fetching geolocation:", error.message);
         }
      );
   } else {
      console.warn("Geolocation is not supported by this browser.");
   }
};
